import React from 'react';

import { Button } from '@/ux-common/components/button/button';

import { ErrorMessage } from './error';

export interface ErrorFallbackProps {
  error: Error;
  resetError?: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
  const handleResetError = () => {
    resetError?.();
    // Use window.location for navigation since Router context may not be available
    window.location.href = '/';
  };

  return (
    <ErrorMessage errorMessage={error.message}>
      {resetError && (
        <Button onClick={handleResetError} className={'btn btn-tier2'}>
          {'Try Again'}
        </Button>
      )}
    </ErrorMessage>
  );
};
